export function formatLocaleTimeString(
  date: Date,
  locale?: Intl.LocalesArgument,
) {
  return date.toLocaleTimeString(locale, {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
}

/**
 * Formats a Date object to YYYY-MM-DD string in local timezone
 * This avoids timezone issues that occur with toISOString()
 * @param date - The Date object to format
 * @returns Date string in YYYY-MM-DD format
 */
export function formatLocalDate(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

/**
 * Returns a date N days ago as a YYYY-MM-DD string in local time.
 */
export function getDaysAgoDateString(days: number): string {
  const date = new Date();
  date.setDate(date.getDate() - days);
  return formatLocalDate(date);
}
